const shape = {
  borderRadiusXxs: 0.5, // 2px
  borderRadiusXs: 1, // 4px
  borderRadiusSm: 2, // 8px
  borderRadiusMd: 3, // 12px
  borderRadiusLg: 4, // 16px
  borderRadiusXl: 5, // 20px
  borderRadiusXxl: 6, // 24px
  borderRadiusGiant: 8, // 32px
  borderRadiusRound: 999 // round corner
};

export default shape;
